import HikSetMileageModal from './hik-set-mileage-modal.vue'
export default HikSetMileageModal
